import { Reveal } from "@/components/site/Reveal";

const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-manor-bg">
    <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.28em] uppercase text-manor-sage">
          Dehradun · Doon Valley · 24–27 September
        </p>
        <img
          src="/manor-house-white.png"
          alt="The Manor House — Boutique Stays"
          data-testid="footer-logo"
          className="mt-10 w-full max-w-[9rem]"
        />
        <p className="mt-8 font-display text-4xl font-light italic tracking-tight text-manor-text/80 md:text-5xl">
          in circle with TMH · The Mindful Human
        </p>
      </Reveal>

      <div className="mt-20 flex flex-col gap-10 border-t border-white/10 pt-10 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap gap-x-10 gap-y-4">
          {[
            ["Manifesto", "#manifesto"],
            ["Itinerary", "#itinerary"],
            ["Gallery", "#venue"],
            ["Rates", "#rates"],
            ["Reserve", "#reserve"],
          ].map(([label, href]) => (
            <button
              key={href}
              data-testid={`footer-link-${label.toLowerCase()}`}
              onClick={() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" })}
              className="link-underline font-mono text-xs tracking-[0.2em] uppercase text-manor-sage hover:text-manor-text transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
        <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-manor-sage/70">
          © {new Date().getFullYear()} TMH Circle × The Manor House · Made with sound
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
